/**
 * Mobile Portal Dashboard – field ops overview (per PRD §6)
 */

import { Truck, Banknote, MapPin, Send, ClipboardList, Activity } from 'lucide-react';
import { Link } from 'react-router-dom';

function StatCard({
  icon: Icon,
  label,
  value,
  href,
  color,
}: {
  icon: React.ElementType;
  label: string;
  value: string;
  href: string;
  color: string;
}) {
  return (
    <Link to={href} className="rounded-xl border bg-card p-6 block hover:bg-muted/50 transition-colors">
      <div className="flex items-center gap-4">
        <div className={`rounded-full p-3 ${color}`}>
          <Icon className="h-6 w-6" />
        </div>
        <div>
          <p className="text-sm text-muted-foreground">{label}</p>
          <p className="text-2xl font-bold">{value}</p>
        </div>
      </div>
    </Link>
  );
}

export default function Dashboard() {
  return (
    <div className="space-y-6 min-w-0">
      <div>
        <h1 className="text-xl sm:text-2xl font-bold tracking-tight">Mobile Portal</h1>
        <p className="text-sm sm:text-base text-muted-foreground">Field ops: mobile units, ATMs, activity</p>
      </div>

      <div className="grid gap-3 sm:gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
        <StatCard
          icon={MapPin}
          label="Map"
          value="Units, NamPost, ATMs"
          href="/map"
          color="bg-violet-500/10 text-violet-600"
        />
        <StatCard
          icon={Truck}
          label="Mobile Units"
          value="View & log"
          href="/mobile-units"
          color="bg-primary/10 text-primary"
        />
        <StatCard
          icon={Banknote}
          label="ATMs"
          value="Status & maintenance"
          href="/atms"
          color="bg-green-500/10 text-green-600"
        />
        <StatCard
          icon={Send}
          label="Requests"
          value="Equipment & trips"
          href="/requests"
          color="bg-amber-500/10 text-amber-600"
        />
        <StatCard
          icon={ClipboardList}
          label="Activity"
          value="Inspection, repair"
          href="/activity"
          color="bg-blue-500/10 text-blue-600"
        />
      </div>

      <div className="rounded-xl border bg-card p-6">
        <h2 className="font-semibold mb-2">Welcome, Field Ops</h2>
        <p className="text-sm text-muted-foreground">
          Use <strong>Mobile Units</strong> to view units, equipment, drivers and log activity (inspection, repair, service).
          Use <strong>ATMs</strong> to view status, cash level and log maintenance or replenishment. All actions are
          recorded for audit (per PRD §6).
        </p>
      </div>
    </div>
  );
}
